module.exports = __webpack_public_path__ + "img/SAS_BlueKnightlyShield.9f52b34e.png";